import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    users: [],
    user: {},
    loading: false,
    error: null,
    message: null,
    isAuthenticated: false,
    roles: [],
};

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        defaultCalling: (state) => {
            state.error = null;
            state.message = null;
        },
        apiCallingStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        apiCallingFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        signUp: (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
        },
        login: (state, action) => {
            state.loading = false;
            localStorage.setItem('token', action.payload.data?.token);
            state.message = action.payload.message;
            state.isAuthenticated = true;
        },
        userUpdate: (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
            state.user = action.payload.data;
        },
        setUser: (state, action) => {
            state.loading = false;
            state.user = action.payload.data;
        },
        setUsers: (state, action) => {
            state.loading = false;
            state.users = action.payload.data;
        },
        setUserSession: (state, action) => {
           state.loading = false;
           state.isAuthenticated = true;
        },
        setChangePassword: (state, action) => {
            state.loading = false;
            state.message = action.payload.message;
        },
        signOut: (state, action) => {
            state.loading = false;
            state.user =  null;
            state.message = null;
            state.isAuthenticated = false;
            localStorage.clear();
        },
        userRoles: (state, action) => {
            state.loading = false;
            state.roles = action.payload.data;
        }
    },
});

export const {
    apiCallingStart,
    apiCallingFailure,
    signUp,
    login,
    signOut,
    setUser,
    setUsers,
    setUserSession,
    setChangePassword,
    defaultCalling,
    userUpdate,
    userRoles
} = userSlice.actions;

export default userSlice.reducer;
